import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { TODO_COMMENTS_QUERY_KEY_PREFIX } from "@/components/MyStudents/Submissions/composables/useTodoComments";
import profileService from "@/services/profile.js";

export interface DeleteTodoCommentVariables {
  applicationId: string;
  todoId: string;
  commentId: string;
}

export const useDeleteTodoComment = (
  useMutationOptions?: UseMutationOptions<void, Error, DeleteTodoCommentVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteTodoCommentVariables>({
    mutationFn: async ({ applicationId, todoId, commentId }) => {
      await profileService.deleteTodoComment(applicationId, todoId, commentId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [TODO_COMMENTS_QUERY_KEY_PREFIX] });
    },
    ...useMutationOptions,
  });
};
